import { httpRequest } from "@services/http";
import { Ad } from "@models/Ad.model";
import { AdSerializer } from "@models/serializers/adSerializer";

export class CommandListAds {
  async run(adIds: number[]) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/ads?ad_ids=${adIds.join(',')}`;

    const response = await httpRequest(url, {
      method: "GET",
    });
    return this.deserialize(response);
  }

  deserialize(data: any): Ad[] {
    const serializer = new AdSerializer();
    return serializer.deserializeList(data);
  }
}
